import React, { useEffect, useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import HighchartsSankey from "highcharts/modules/sankey";
import { Box, Typography } from "@material-ui/core";
import useStyles from "./Styles";
import { useSelector } from "react-redux";
import { toolbarHeight } from "components/app/Styles";
import { aboutDrawerWidth, aboutTogglebarWidth, chartTogglebarWidth, filterContainerHeight, chartTitleHeight } from "./Styles";
import { getWindowSize } from "./utils";
import useGetViewPortDimensions from "hooks/useGetViewPortDimensions";

HighchartsSankey(Highcharts);

let nodes = [
  // {
  //   id: "CO1.3",
  //   column: 0,
  //   name: "CO River Water Available 1.3M",
  //   color: "#97B0DC",
  // },
  // {
  //   id: "CO1",
  //   name: "CO River Water Available 1M",
  //   column: 2,
  //   color: "#97B0DC",
  // },
  // {
  //   id: "CO900",
  //   name: "CO River Water Available 900K",
  //   column: 4,
  //   color: "#97B0DC",
  // },
  // {
  //   id: "CO850",
  //   name: "CO River Water Available 850K",
  //   column: 6,
  //   color: "#97B0DC",
  // },
  // {
  //   id: "CO800",
  //   name: "CO River Water Available 800K",
  //   column: 8,
  //   color: "#97B0DC",
  // },
  // {
  //   id: "CO700",
  //   name: "CO River Water Available 700K",
  //   column: 0,
  //   color: "#97B0DC",
  // },
  // {
  //   id: "CO600",
  //   name: "CO River Water Available 600K",
  //   column: 2,
  //   color: "#97B0DC",
  // },
  // {
  //   id: "CO500",
  //   name: "CO River Water Available 500K",
  //   column: 4,
  //   color: "#97B0DC",
  // },
  // {
  //   id: "CO400",
  //   name: "CO River Water Available 400K",
  //   column: 6,
  //   color: "#97B0DC",
  // },
  // {
  //   id: "CO300",
  //   name: "CO River Water Available 300K",
  //   column: 8,
  //   color: "#97B0DC",
  // },
  {
    id: "CO1.3",
    column: 0,
    name: " ",
    color: "#97B0DC",
  },
  {
    id: "CO1",
    name: " ",
    column: 2,
    color: "#97B0DC",
  },
  {
    id: "CO900",
    name: " ",
    column: 4,
    color: "#97B0DC",
  },
  {
    id: "CO850",
    name: " ",
    column: 6,
    color: "#97B0DC",
  },
  {
    id: "CO800",
    name: " ",
    column: 8,
    color: "#97B0DC",
  },
  {
    id: "CO700",
    name: " ",
    column: 0,
    color: "#97B0DC",
  },
  {
    id: "CO600",
    name: " ",
    column: 2,
    color: "#97B0DC",
  },
  {
    id: "CO500",
    name: " ",
    column: 4,
    color: "#97B0DC",
  },
  {
    id: "CO400",
    name: " ",
    column: 6,
    color: "#97B0DC",
  },
  {
    id: "CO300",
    name: " ",
    column: 8,
    color: "#97B0DC",
  },
];

let remove;

function CentralArizonaSankey() {
  const classes = useStyles();
  const { toggle_about } = useSelector((state) => state.central_arizona);
  const [windowSize, setWindowSize] = useState(getWindowSize());
  const [options, setOptions] = useState(null);
  const { scenario } = useSelector((state) => state.central_arizona);
  const { isMobile } = useGetViewPortDimensions();

  const createSankeyData = () => {
    const data = [];
    const droughtPlanWater = ["1.3", "1", "900", "850", "800"];
    const severeWater = ["700", "600", "500", "400", "300"];
    const planToUse = scenario === "DCP Cuts" ? droughtPlanWater : severeWater;
    const useType = ["Tapwater", "Industry", "Turf", "Agriculture", "Aquifer Recharge"];
    const allData = {
      1.3: [320468, 17650, 20360, 557276, 380589],
      1: [320468, 17604, 20360, 461144, 310400],
      900: [317708, 17595, 20360, 403366, 236056],
      850: [315202, 17604, 19456, 383360, 226136],
      800: [307452, 17585, 9252, 282706, 205751],
      700: [278200, 17546, 6174, 236848, 180683],
      600: [244236, 17507, 5978, 178506, 175750],
      500: [210011, 19326, 5538, 136609, 152345],
      400: [175761, 17248, 3575, 103051, 119358],
      300: [137106, 7459, 2532, 78222, 112912],
    };
    const colorMapping = {
      Tapwater: "#2352D0",
      Industry: "#DE3E40",
      Turf: "#69A4DC",
      Agiculture: "#96D9E4",
      Aquifer: "#F3C745",
    };
    for (let i = 0; i < planToUse.length; i++) {
      for (let j = 0; j < useType.length; j++) {
        const innerMap = [];
        // CO1.3
        innerMap.push("CO" + planToUse[i]);
        // Tap1.3
        innerMap.push(useType[j] + planToUse[i]);
        // 320468
        innerMap.push(allData[planToUse[i]][j]);
        nodes.push({
          id: useType[j] + planToUse[i],
          name: useType[j],
          color: colorMapping[useType[j]],
        });

        if (i > 0) {
          const connectingMap = [];
          connectingMap.push(useType[j] + planToUse[i - 1]);
          connectingMap.push("CO" + planToUse[i]);
          connectingMap.push(allData[planToUse[i]][j]);
          data.push(connectingMap);
        }

        data.push(innerMap);
      }
    }

    return data;
  };

  const updateChartAndRemoveItem = () => {
    updateChart();
    if (remove) {
      remove.forEach((item) => item.destroy());
    }
  }

  useEffect(updateChartAndRemoveItem, [scenario, windowSize, toggle_about]);

  const labels =
    scenario === "DCP Cuts"
      ? ["1.3M", "1M", "900K", "850K", "800K"]
      : ["700K", "600K", "500K", "400K", "300K"];

  const updateChart = () => {
    const optionsTemp = {
      chart: {
        //   type: "sankey",
        plotBackgroundColor: "transparent",
        backgroundColor: "transparent",
        width: isMobile ? 380 :
          windowSize.innerWidth - 
          chartTogglebarWidth - 
          ( toggle_about ? aboutDrawerWidth : aboutTogglebarWidth ) - 
          80, // 80 for padding
        height:
          windowSize.innerHeight -
          toolbarHeight -
          filterContainerHeight -
          chartTitleHeight -
          75 -
          55,
        events: {
          render: function () {
            const positions = [
              20,
              (this.chartWidth / 9) * 2 + 7,
              (this.chartWidth / 9) * 4,
              (this.chartWidth / 9) * 6,
              (this.chartWidth / 9) * 8 - 7,
            ];

            remove = labels.map((label, i) => {
              let oneLabel = this.renderer
                .text(labels[i])
                .attr({
                  x: positions[i],
                  y: this.chartHeight - 2,
                  align: "center",
                })
                .css({
                  fontSize: "12px",
                })
                .add();
              return oneLabel;
            });
          },
        },
      },
      title: {
        text: undefined,
        style: {
          fontFamily: "Arial",
        },
      },
      xAxis: {
        labels: {
          style: {
            fontFamily: "Arial",
          },
        },
        text: undefined,
      },
      series: [
        {
          keys: ["from", "to", "weight"],
          data: createSankeyData(),
          dataLabels: {
            allowOverlap: true,
            //   inside: true,
            // rotation: 270,
          },

          nodes: nodes,
          type: "sankey",
        },
      ],
      credits: {
        enabled: false,
      },
      tooltip: {
        enabled: false,
      },
      plotOptions: {
        sankey: {
          states: {
            hover: {
              enabled: false,
            },
            inactive: {
              opacity: 1,
            },
          },
          borderWidth: 0,
          // showInLegend: true,
          label: {
            enabled: false,
          },
        },
        series: {
          point: {
            events: {
              legendItemClick: function () {
                return false; // <== returning false will cancel the default action
              },
            },
          },
          // removes highlight on hover feature
          enableMouseTracking: false,
          connectNulls: true,
        },
      },
    };
    setOptions(optionsTemp);
  };

  //gets windowSize to set width of barchart
  useEffect(() => {
    const handleWindowResize = () => {
      setWindowSize(getWindowSize());
    };
    window.addEventListener("resize", handleWindowResize);
    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, []);
  return (
    <Box className={classes.chartContainer}>
      <HighchartsReact highcharts={Highcharts} options={options} />
      {scenario === "DCP Cuts" ? (
        <Typography
          variant="body2"
          component="p"
          className={classes.sankeyTitle}
        >
          CO River Water Available : 800K - 1.3M
        </Typography>
      ) : (
        <Typography
          variant="body2"
          component="p"
          className={classes.sankeyTitle}
        >
          CO River Water Available : 300K - 700K
        </Typography>
      )}
    </Box>
  );
}

export default CentralArizonaSankey;
